var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_722_101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_722_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -7,
    width: 90,
    height: 87,
    fill: "#004FD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_722_101",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_722_101",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmElEQVR4nO2YPUsDQRCGH4KCWCiolbVY2mphYXnBxlKsLe3EQtDaIqUW1v4AG8VSsBT/gBAQvNgINgEtDOjKyQSCub0zuY/MhXlgi9zMbd6X2RmWgzFnFrgBOoBTsjrANTAziJGGAuHOsxqDVKMtL62ihzXR1BaNqRzIC7fo40607aclTgDPkryJPrZEWwuYTErckcRHoIY+aqIt0ridlHgvSbvoZU80PvgSNiThFZhCL9PAm2hdj0u4kuAR+jkRrZd/A8vAF/ABLKCfReBTNC/1Bs7F4RnV4UI0n3YfzAHvce6UswJ8yymajx4cK7h2ZF2HkZEnBUKyriY9P6qK6+o3I0pwVhEPgdxKkxqymSEeyn8MXZHoOv8iIusJeWEJ0ynMYqSVslHfhiXHXZFG4qqYZ3woI3XZ0HdG+zb0mM8zXujUGksj9Zgq5hkvdGqNZbPHYUZGObXKjLsim73MuDMjHqwigh0t6xEP1iOC9Yj1iAfrEcF6JO8eUf856L8EKWZG/oFOO86MaK1IWEKTljIEgoqb+R0CP1MlDu/FOSWaAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNas);
export default __webpack_public_path__ + "static/media/NAS.6d9e60877ca28611c2f25eb6740081bc.svg";
export { ForwardRef as ReactComponent };